import { OneDataCollection } from '@factorialco/f0-react/dist/experimental'
import { ArrowCycle, Plus, Target, People, ChartLine } from '@factorialco/f0-react/icons/app'
import { IncentivesCompensationPlansDataCollectionDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useGraphqlDataCollectionSource } from 'modules/core/hooks/useGraphqlDataCollectionSource'
import i18n from 'modules/core/lib/i18n'
import { periodLabel } from 'modules/incentives/lib/period'
import { recurrenceLabel } from 'modules/incentives/lib/recurrence'
import { useNavigation } from 'modules/core/hooks/useNavigation'

export const CompensationPlansDataCollection = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const source = useGraphqlDataCollectionSource({
    totalItemSummary: true,
    document: IncentivesCompensationPlansDataCollectionDocument,
    perPage: 20,
    mapData: (data) => data.incentives.compensationPlansConnection.nodes || [],
    mapPagination: (data) => ({
      total: data.incentives.compensationPlansConnection.totalCount ?? 0,
    }),
    mapVariables: ({ search }) => ({
      companyId: company.id,
      search,
    }),
    search: {
      enabled: true,
    },
    primaryActions: () => ({
      label: i18n.t('incentives.list.new'),
      icon: Plus,
      onClick: () => {
        /* TODO */
      },
    }),
    itemUrl: (item) =>
      navigation.compensations.incentives.plans.id.fullPath({ id: String(item.id) }),
  })

  const emptyState = {
    'no-data': {
      emoji: '💰',
      title: i18n.t('incentives.list.empty_state.label'),
      description: i18n.t('incentives.list.empty_state.description'),
      actions: [
        {
          label: i18n.t('incentives.list.empty_state.button'),
          variant: 'outline' as const,
          onClick: () => {},
        },
      ],
    },
  }

  return (
    <OneDataCollection
      fullHeight
      source={source}
      emptyStates={emptyState}
      visualizations={[
        {
          type: 'card',
          options: {
            title: (item) => item.name,
            cardProperties: [
              {
                label: i18n.t('incentives.plan.recurrence'),
                icon: ArrowCycle,
                render: ({ recurrence }) => recurrenceLabel(recurrence),
              },
              {
                label: i18n.t('incentives.list.employees.label'),
                icon: People,
                render: () =>
                  i18n.tp('incentives.list.employees.content', {
                    count: 0,
                  }),
              },
              {
                label: i18n.t('incentives.list.goals.label'),
                icon: ChartLine,
                render: () =>
                  i18n.tp('incentives.list.goals.content', {
                    count: 0,
                  }),
              },
              {
                label: i18n.t('incentives.list.period_achievement.label'),
                icon: Target,
                render: ({ recurrence, currentPeriod }) =>
                  i18n.t('incentives.list.period_achievement.content', {
                    current_period: currentPeriod
                      ? periodLabel(recurrence, currentPeriod, { excludeYear: true })
                      : '-',
                    achievement: '0',
                  }),
              },
            ],
          },
        },
      ]}
    />
  )
}
